import React from 'react';

import { Table, TableBody } from '@/component-style/Table';
import TableWrapper  from '@/components/UI/TableWrapper';
import PageSelector from '@/components/UI/PageSelector';
import Header from './Header';
import Item from './Item';

const TableCashReports = props => {

  const { expenses } = props;

  return (
    <TableWrapper title = "代墊款支領列表">
      <Table>
        <Header/>
        <TableBody>
          {
            expenses.map(expense => 
              <Item
                key = { expense.expenseID }
                expense = { expense }
              />
            )
          }
        </TableBody>
      </Table>
      <PageSelector
        current = { props.currentPage }
        total = { props.totalCount }
        pageChangedHandler = { props.pageChangedHandler }
      />
    </TableWrapper>
  );
};

export default TableCashReports;
